import { UserApi } from "@socotec.io/ssp-back-sdk";
import { sspConfig } from "@/setup/openApiConfig";

export const userApi = new UserApi(sspConfig);
